<script lang="ts">
  import { getCopy } from "../../lib/stores/copy";
  import BaseCard from "../Card/BaseCard.svelte";
  import { navigateToPath } from "../../lib/routing";
  import PATHS from "../../lib/constants/routePaths";
  import Pill from "../Pill.svelte";
  import { TypographyType } from "../../lib/constants/typographyMap";
  import Typography from "../Typography.svelte";
  import type { Gift } from "../../types/gift";
  import type { Variation } from "../../lib/helpers/steps/menuItems";

  export let selectedGift: Gift;
  export let hideEditButton: boolean = false;
  export let onCardEditCallback: () => Promise<void> = async () => {};

  const onEditClick = () => {
    void (async () => {
      await onCardEditCallback();
      navigateToPath(PATHS.MENU);
    })();
  };

  const getDefaultImage = (gift: Gift) => {
    const variation = gift.variations?.find((variation: Variation) => variation.isDefaultImage);
    return variation?.image;
  };

  const setImage = (gift: Gift) => {
    if (!gift) return;
    if (!gift.variations?.length) return gift.image;

    const variation = gift.variations?.find((variation: Variation) => variation.name === gift.variation);
    return variation?.image ?? getDefaultImage(gift);
  };

  $: copy = $getCopy("review") as Record<string, string>;
  $: image = setImage(selectedGift);
</script>

<BaseCard headerCopy={copy.selectedGiftHeaderCopy} {onEditClick} {hideEditButton}>
  <svelte:fragment slot="card body">
    <div class="flex flex-row gap-4 max-h-20">
      <div
        class="bg-cover bg-center rounded-lg block h-20 w-20"
        role="img"
        aria-label={image}
        style={`background-image: url("${image}");`}>
      </div>
      <div class="flex flex-col gap-3 justify-start">
        <div class="flex flex-col">
          <Typography mobile={TypographyType.Body1Medium} desktop={TypographyType.Headline5Medium}>
            {selectedGift?.visible_name ?? selectedGift?.name}
          </Typography>
          {#if selectedGift?.description}
            <Typography
              mobile={TypographyType.Body2Regular}
              desktop={TypographyType.Body2Regular}
              --font-color="var(--color-purple-90)">
              {selectedGift?.description}
            </Typography>
          {/if}
        </div>
        <div class="flex gap-2">
          {#if !selectedGift?.isGiftWithSingleVariation}
            <Pill text={selectedGift?.visible_variation ?? selectedGift?.variation} />
          {/if}
          {#if !selectedGift?.isGiftWithSingleVariation && selectedGift.visible_variation_2}
            <Pill text={selectedGift?.visible_variation_2} color="blue" />
          {/if}
        </div>
      </div>
    </div>
  </svelte:fragment>
</BaseCard>
